import axios from "axios";

const BuyerBaseUrl = (process.env.REACT_APP_BUYER_BASE_URL || "https://devapi.tazty.in").replace(/\/+$/, "");
const BuyerApiKey = process.env.REACT_APP_BUYER_API_KEY || "";

export type HttpMethod = "get" | "post" | "put" | "patch" | "delete";

export const apiHandler = async (
  method: HttpMethod,
  url: string,
  payload?: any,
  config: any = {},
  returnFull: boolean = false
) => {
  try {
    let response;
    const normalizedUrl = url.startsWith("/") ? url : `/${url}`;
    const requestUrl = `${BuyerBaseUrl}${normalizedUrl}`;
    const requestConfig = {
      ...config,
      headers: {
        ...(config?.headers || {}),
        ...(BuyerApiKey
          ? {
              "x-api-key": BuyerApiKey,
              "X-API-KEY": BuyerApiKey,
              "api-key": BuyerApiKey,
            }
          : {}),
      },
    };

    // Correct handling for GET/DELETE (no payload)
    if (method === "get" || method === "delete") {
      response = await axios[method](requestUrl, requestConfig);
    } else {
      response = await axios[method](requestUrl, payload, requestConfig);
    }

    return returnFull ? response : response.data;
  } catch (error) {
    console.error(`API ${method.toUpperCase()} ${url} failed:`, error);
    throw error;
  }
};